import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

const { FiCalendar, FiFileText } = FiIcons;

const Dashboard = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchItems();
  }, []);

  const fetchItems = async () => {
    try {
      const res = await api.get('/public/items');
      setItems(res.data.items);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-4xl mx-auto">
        <header className="mb-8 border-b pb-4">
          <h1 className="text-3xl font-bold text-gray-900">Últimas Novedades</h1>
          <p className="text-gray-600">Resumen cronológico de normativa BOE</p>
        </header>

        {loading ? (
          <div className="text-center py-10 text-gray-500">Cargando boletín...</div>
        ) : (
          <div className="space-y-4">
            {items.map(item => (
              <div key={item.id} className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
                <div className="flex justify-between items-start">
                  <span className={`px-2 py-1 text-xs font-bold rounded mb-2 inline-block ${
                    item.rango_normativo?.includes('Ley') ? 'bg-purple-100 text-purple-700' : 'bg-blue-100 text-blue-700'
                  } `}>
                    {item.rango_normativo || 'Normativa'}
                  </span>
                  <span className="text-xs text-gray-500 flex items-center">
                    <SafeIcon icon={FiCalendar} className="mr-1 w-3 h-3" />
                    {format(new Date(item.fecha_publicacion), "d MMM yyyy", { locale: es })}
                  </span>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  <Link to={`/item/${item.id}`} className="hover:text-blue-600">
                    {item.titulo}
                  </Link>
                </h3>
                <p className="text-sm text-gray-600 line-clamp-3 mb-4 leading-relaxed">
                  {item.summary_short || item.titulo}
                </p>
                <div className="flex gap-4 text-sm border-t pt-3">
                  <Link to={`/item/${item.id}`} className="text-blue-800 font-medium hover:underline">
                    Ver análisis completo
                  </Link>
                  <a href={item.url_oficial} target="_blank" className="text-gray-400 hover:text-gray-600 flex items-center">
                     <SafeIcon icon={FiFileText} className="mr-1 w-3 h-3" />
                     PDF Oficial
                  </a>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;